/**
 * True for requests to static files under `assets/` (e.g. the SVGs `angular-svg-icon` fetches via
 * HttpClient so it can inline them for CSS styling). Those go through the same interceptor chain
 * as API calls, so without this check they'd pick up headers - the JWT bearer token, the SignalR
 * connection id - that a static asset host has no use for and shouldn't receive.
 */
export function isStaticAssetRequest(url: string): boolean {
  return /(^|\/)assets\//.test(url);
}
